import React from 'react'
import Pt from 'prop-types'
import { FormGroup, Radio, Table } from 'react-bootstrap'

import { ClientRecord } from 'internal-components/src/records'

import './MspClientUserSelector.css'

const radioGroup = 'msp-client-user-selector-group'

export default function MspClientUserSelector({
  client,
  selectedUser,
  selectUser,
}) {
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <FormGroup>
      <Table bordered hover className="msp-client-user-selector">
        <thead>
          <tr>
            <th />
            <th style={{ width: '100%' }}>Name</th>
          </tr>
        </thead>
        <tbody>
          {client.authorisedUsersForPartners.entrySeq().map(([id, user]) => (
            <tr key={id} onClick={() => selectUser(id)}>
              <td>
                <Radio
                  checked={selectedUser === id}
                  name={radioGroup}
                  onChange={() => selectUser(id)}
                />
              </td>
              <td>
                <strong>{user}</strong>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </FormGroup>
  )
}

MspClientUserSelector.propTypes = {
  client: Pt.instanceOf(ClientRecord).isRequired,
  selectedUser: Pt.number,
  selectUser: Pt.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/MspClientUserSelector.jsx